/* ==============================================================================================
 * [MUNICIPAL] EXPORT LIST TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/municipal/exportList.json";
	var tableElement = document.querySelector("#municipalExportListTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "type",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "name",
				className: "c-table__cell",
			},
			{
				data: "number",
				className: "c-table__cell",
			},
			{
				data: null,
				orderable: false,
				className: "c-table__cell c-table__cell--remove",
				defaultContent: "",
			},
		],
		columnDefs: [
			{
				targets: [3],
				width: "1%",
				render: CGS.renderRemoveCell,
			},
		],
		initComplete: CGS.createRetractTableWrapper,
		dom: "<'top'>rt<'c-tableFooter'pi<'c-tableExport c-tableExport--batch'B>>",
		buttons: [
			CGS.getClearExportListButton(),
			CGS.getExportToExcelButton(),
		],
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
